module.exports = __webpack_public_path__ + "static/media/6Solar.39a013b9.gif";